var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlowers = function SvgFlowers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.75 4.75.477-.579A.75.75 0 0 0 7 4.75h.75ZM12 8.25l-.477.579a.75.75 0 0 0 .954 0L12 8.25Zm4.25-3.5H17a.75.75 0 0 0-1.227-.579l.477.579Zm-8.977.579 4.25 3.5.954-1.158-4.25-3.5-.954 1.158Zm5.204 3.5 4.25-3.5-.954-1.158-4.25 3.5.954 1.158ZM15.5 4.75v4.5H17v-4.5h-1.5Zm-3.25 7.75h-.5V14h.5v-1.5ZM8.5 9.25v-4.5H7v4.5h1.5Zm3.25 3.25A3.25 3.25 0 0 1 8.5 9.25H7A4.75 4.75 0 0 0 11.75 14v-1.5Zm3.75-3.25a3.25 3.25 0 0 1-3.25 3.25V14A4.75 4.75 0 0 0 17 9.25h-1.5Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5v5.75",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.968 16.965a.75.75 0 0 0-1.436-.43l1.436.43Zm-10.5-.43a.75.75 0 1 0-1.436.43l1.436-.43ZM12 20c2.397 0 3.888-.67 4.793-1.424.447-.372.734-.752.913-1.05a3.109 3.109 0 0 0 .24-.494 1.352 1.352 0 0 0 .019-.055l.002-.006v-.003l.001-.001s0-.002-.718-.217a48.087 48.087 0 0 1-.718-.218v-.002l.002-.003.001-.004v.001a1.635 1.635 0 0 1-.115.23c-.103.172-.284.417-.588.67-.595.496-1.73 1.076-3.832 1.076V20Zm0-1.5c-2.103 0-3.237-.58-3.832-1.076a2.672 2.672 0 0 1-.587-.67 1.636 1.636 0 0 1-.116-.23v-.001l.001.004.001.003v.002l.001.001s0 .002-.718.217a43.653 43.653 0 0 0-.718.218l.001.003.002.006a1.64 1.64 0 0 0 .067.176c.041.097.103.225.192.373.18.298.467.678.913 1.05C8.112 19.33 9.603 20 12 20v-1.5Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.984 6a2.25 2.25 0 0 1 4.032 0",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFlowers;